import debounce from 'lodash/debounce'
import { WholeReportRepository } from '@/models/Dashboard'

const actions = {
  SEARCH: debounce(async ({ commit, state }) => {
    const { sortBy, descending } = state.sortOptions
    const { serveStatus, keyword } = state.filter
    const { pageSize, pageNo } = state.page
    commit('SET_LOADING', true)
    const result = await WholeReportRepository.search({
      sortBy,
      descending,
      serveStatus,
      keyword,
      pageNo,
      pageSize,
    })
    commit('SET_SEARCH_RESULT', result)
    commit('SET_LOADING', false)
  }, 500),
  UPDATE_SORT_OPTIONS({ commit }, { sortBy, descending }) {
    commit('UPDATE_SORT_OPTIONS', { sortBy, descending })
  },
  UPDATE_SERVE_STATUS_FILTER({ commit }, serveStatus) {
    commit('UPDATE_SERVE_STATUS_FILTER', serveStatus)
  },
  UPDATE_KEYWORD_FILTER({ commit }, keyword) {
    commit('SET_KEYWORD_FILTER', keyword)
  },
  UPDATE_PAGE({ commit, getters }, { pageSize, pageNo }) {
    commit('SET_PAGE', { pageSize: pageSize || getters.page.pageSize, pageNo })
  },
}

export default actions
